// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__31Ruw","boxTitle":"Qualiphy_boxTitle__2IJKt","box":"Qualiphy_box__3I7Vj","toggleWrap":"Qualiphy_toggleWrap__1hGBM"};